import { jsx as f, jsxs as e } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.es.js";
import { SvgIcon } from "@mui/material";
function l(i) {
  return /* @__PURE__ */ f(SvgIcon, { ...i, children: /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ f("path", { d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z", fill: "#00BB8C" }),
    /* @__PURE__ */ f("path", { d: "M17.7397 18.26C16.2297 19.65 14.2098 20.5 11.9998 20.5C9.78976 20.5 7.76977 19.65 6.25977 18.26C6.69977 16.88 7.83979 15.5699 10.2898 15.5699H13.7097C16.1497 15.5699 17.2897 16.89 17.7397 18.26ZM15.0078 10C15.0078 8.343 13.6648 7 12.0078 7C10.3508 7 9.00781 8.343 9.00781 10C9.00781 11.657 10.3508 13 12.0078 13C13.6648 13 15.0078 11.657 15.0078 10Z", fill: "#171F36" })
  ] }) });
}
export {
  l as UserCircleDuotone
};
//# sourceMappingURL=user-circle-duotone.es.es.js.map
